var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "TcCalendarDay" }, [
    _c("h5", { staticClass: "text-center" }, [
      _vm._v(_vm._s(_vm.week_day_name))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "text-center text-4xl font-bold" }, [
      _vm._v(_vm._s(_vm.date.date.getDate()))
    ]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "flex flex-col items-center gap-3 mt-5 pb-10" },
      _vm._l(_vm.date.slots, function(slot) {
        return _c(
          "li",
          { key: slot.time, staticClass: "mb-0 rounded-lg shadow-md" },
          [
            slot.active == true
              ? _c(
                  "div",
                  {
                    staticClass:
                      "bg-green-400 hover:bg-green-500 text-white py-2 text-lg px-16 rounded-lg cursor-pointer",
                    on: {
                      click: function($event) {
                        return _vm.newAppointmentClick(slot)
                      }
                    }
                  },
                  [_c("span", [_vm._v(_vm._s(slot.time))])]
                )
              : _c(
                  "div",
                  {
                    staticClass:
                      "bg-gray-400 py-2 text-lg px-16 rounded-lg opacity-20"
                  },
                  [_vm._v(_vm._s(slot.time))]
                )
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }